import type { CompetitionId } from '@ps/web-sports-api-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { RootState } from '@swf/core/store';
import { DefaultLink } from '@swf/sports/components';
import Badges from '@swf/sports/components/Badges/Badges';

import { useSportsLandingPageWidget } from '../../../../model';

import { TXTWCL_odds_boost_selections } from './CompetitionLink.messages.json';
import styles from './CompetitionLink.scss';

export interface Props {
  competitionId: CompetitionId;
}

const CompetitionLink: React.FC<Props> = ({ competitionId }) => {
  const { widgetSelect } = useSportsLandingPageWidget();

  const competition = useSelector((state: RootState) =>
    widgetSelect.competition(state, competitionId)
  );
  const eventType = useSelector((state: RootState) =>
    widgetSelect.eventType(state, competition.eventTypeId)
  );

  const { formatMessage } = useRegulatoryIntl();

  const { eventTypeId, eventTypeSlug } = eventType;
  const { competitionSlug, oddsBoostCount, competitionName } = competition;

  return (
    <DefaultLink
      alias="sportsCompetition"
      values={{ eventTypeSlug, eventTypeId, competitionSlug, competitionId }}
    >
      {competitionName}
      {oddsBoostCount ? (
        <Badges
          count={oddsBoostCount}
          iconName="price-boost"
          iconLabel={formatMessage(TXTWCL_odds_boost_selections)}
          className={styles.badge}
        />
      ) : null}
    </DefaultLink>
  );
};

export default CompetitionLink;
